import { render } from "./ComplianceCheckingDialog.vue?vue&type=template&id=36ade460"
import script from "./ComplianceCheckingDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceCheckingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__